import React from 'react';

export default function TotalRewardsCard({ stats }) {
  console.log(stats);
  return (
    <section className={'shadow p-5 bg-white mt-5'}>
      <div>
        <h3 className={'font-medium text-base lg:text-lg'}>
          Total Rewards ({stats.total_rewards_current_month.current_month})
        </h3>
      </div>
      <div className={'mt-3 flex flex-row justify-between flex-wrap'}>
        <div className={'w-1/2'}>
          <h3 className={'text-yellow-500 font-normal'}>Airtime</h3>
          <p className={'text-xl lg:text-3xl text-gray-500 font-semibold'}>
            {stats.total_rewards_current_month.current_rewards_airtime}
          </p>
        </div>
        <div className={'w-1/2'}>
          <h3 className={'text-yellow-500 font-normal'}>Gift Cards</h3>
          <p className={'text-xl lg:text-3xl text-gray-500 font-semibold'}>
            {stats.total_rewards_current_month.current_rewards_giftcards}
          </p>
        </div>
        <div className={'w-1/2'}>
          <h3 className={'text-yellow-500 font-normal'}>Cummulative</h3>
          <p className={'text-xl lg:text-3xl text-gray-500 font-semibold'}>
            {stats.total_rewards_current_month.total_cummulative}
          </p>
        </div>
      </div>
    </section>
  );
}
